import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const StatCard = ({ title, value, subtitle, icon: Icon, color = 'blue', trend }) => {
  const colorMap = {
    blue:   { bg: 'bg-blue-50',   icon: 'bg-blue-600',   text: 'text-blue-600'   },
    green:  { bg: 'bg-green-50',  icon: 'bg-green-600',  text: 'text-green-600'  },
    purple: { bg: 'bg-purple-50', icon: 'bg-purple-600', text: 'text-purple-600' },
    orange: { bg: 'bg-orange-50', icon: 'bg-orange-600', text: 'text-orange-600' },
    red:    { bg: 'bg-red-50',    icon: 'bg-red-600',    text: 'text-red-600'    },
    teal:   { bg: 'bg-teal-50',   icon: 'bg-teal-600',   text: 'text-teal-600'   },
  };
  const c = colorMap[color] || colorMap.blue;

  return (
    <div className={`card hover:shadow-md transition-shadow duration-200 ${c.bg}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">{title}</p>
          <p className={`text-3xl font-bold ${c.text} mb-1`}>{value}</p>
          {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
          {trend !== undefined && (
            <div className={`flex items-center gap-1 mt-2 text-xs font-medium ${trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-500'}`}>
              {trend > 0 ? <TrendingUp size={12} /> : trend < 0 ? <TrendingDown size={12} /> : <Minus size={12} />}
              {Math.abs(trend)}% vs last month
            </div>
          )}
        </div>
        {Icon && (
          <div className={`${c.icon} p-3 rounded-2xl`}>
            <Icon size={22} className="text-white" />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
